<script setup lang="ts">

import TrackerLayout from "@/interview/components/instance-modal/consumer-product-tracking/trackers/TrackerLayout.vue";
import {Button} from "@/core/components/ui/button";
import {ConsumerProduct} from "@/consumer/interfaces";
import dateHelper from "@/core/helpers/dateHelper";

defineEmits<{
    (e: 'openAlertsDialog'): void;
}>();

defineProps<{
    consumerProducts: ConsumerProduct[];
    done: boolean;
    date: Date | null
}>();
</script>

<template>
  <TrackerLayout
    title="Analyse pharma"
    :state="done ? 'done' : 'to-do'"
  >
    <template v-if="date" #latest>
      Dernier contrôle le {{ dateHelper.shortFormat(date) }}
    </template>
    <template #action>
      <Button
        variant="ghost"
        size="xs"
        class="text-primary"
        @click="$emit('openAlertsDialog')"
      >
        Lancer une analyse
      </Button>
    </template>
  </TrackerLayout>
</template>

<style scoped>

</style>
